import { differenceInCalendarDays, differenceInHours, differenceInMinutes } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { Text } from 'ui';

type P = {
  endTime: Date;
  showInProgressStatus: boolean;
};

const TodoWidgetItemTimeText = ({ endTime, showInProgressStatus }: P) => {
  const { t } = useTranslation();

  const currentTime = new Date();
  const remainingDays = differenceInCalendarDays(endTime, currentTime);
  const remainingHours = differenceInHours(endTime, currentTime);
  const remainingMinutes = differenceInMinutes(endTime, currentTime);

  if (showInProgressStatus) {
    return (
      <>
        {t('In progress: ')}
        <Text weight="bold">
          {t('Hours and minutes left', {
            count: remainingHours,
            minutes: remainingMinutes % 60,
            hours: remainingHours,
          })}
        </Text>
      </>
    );
  }

  if (remainingDays > 3) {
    return <>{t('days_left_more')}</>;
  }

  if (remainingDays > 0) {
    return (
      <>
        {t('days_left', {
          count: remainingDays,
          days: remainingDays,
        })}
      </>
    );
  }

  return (
    <>
      {t('time_left', {
        count: remainingHours,
        hours: remainingHours % 60,
        minutes: remainingMinutes % 60,
      })}
    </>
  );
};

export default TodoWidgetItemTimeText;
